import { render, staticRenderFns } from "./DevManager.vue?vue&type=template&id=7cfb0d86&scoped=true&"
import script from "./DevManager.vue?vue&type=script&lang=js&"
export * from "./DevManager.vue?vue&type=script&lang=js&"
import style0 from "./DevManager.vue?vue&type=style&index=0&id=7cfb0d86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfb0d86",
  null
  
)

export default component.exports